// extracted by mini-css-extract-plugin
export default {"DescriptionContainer":"WebsiteDescription_DescriptionContainer__qlcW2"};